import { Link } from "react-router-dom";
import type { Movie } from "@/mocks/movies";
import { categoryLabels } from "@/mocks/movies";

interface HotRankingProps {
  movies: Movie[];
}

export default function HotRanking({ movies }: HotRankingProps) {
  if (movies.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center gap-2 rounded-lg border border-dashed border-background-300/60 py-16 text-foreground-500">
        <i className="ri-inbox-line text-4xl" />
        <p className="text-sm">暂无推荐内容</p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-1">
      {movies.map((movie, index) => (
        <Link
          key={movie.id}
          to={`/detail/${movie.id}`}
          className="group flex items-center gap-3 rounded-lg border border-background-200/70 bg-background-100 p-3 transition-colors duration-300 hover:border-accent-500/60"
        >
          <span
            className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md font-heading text-lg font-700 ${
              index < 3
                ? "bg-accent-500 text-background-50"
                : "bg-background-200 text-foreground-500"
            }`}
          >
            {index + 1}
          </span>
          <div className="relative h-16 w-12 shrink-0 overflow-hidden rounded-md">
            <img
              src={movie.poster}
              alt={`${movie.title}海报`}
              title={`${movie.title} - 91在线视频`}
              className="h-full w-full object-cover object-top"
            />
          </div>
          <div className="min-w-0 flex-1">
            <h3 className="line-clamp-1 text-sm font-600 text-foreground-950 transition-colors group-hover:text-accent-500">
              {movie.title}
            </h3>
            <p className="mt-1 line-clamp-1 text-xs text-foreground-500">
              {categoryLabels[movie.category]} · {movie.genres.join(" / ")}
            </p>
            <div className="mt-1 flex items-center gap-3 text-xs text-foreground-500">
              <span className="flex items-center gap-1 font-600 text-accent-500">
                <i className="ri-star-fill text-[10px]" />
                {movie.rating.toFixed(1)}
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-fire-line" />
                {movie.views}万
              </span>
            </div>
          </div>
        </Link>
      ))}
    </div>
  );
}